import { render, staticRenderFns } from "./Guide_theQuerV2.vue?vue&type=template&id=2ce15956&scoped=true&"
import script from "./Guide_theQuerV2.vue?vue&type=script&lang=js&"
export * from "./Guide_theQuerV2.vue?vue&type=script&lang=js&"
import style0 from "./Guide_theQuerV2.vue?vue&type=style&index=0&id=2ce15956&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce15956",
  null
  
)

export default component.exports